import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gelatus_app_user')); } catch { return null; }
  });
  const [cargando, setCargando] = useState(false);

  const login = async (email, password) => {
    setCargando(true);
    try {
      const r = await API.post('/auth/login', { email, password });
      const { token, usuario: u } = r.data;
      localStorage.setItem('gelatus_app_token', token);
      localStorage.setItem('gelatus_app_user', JSON.stringify(u));
      setUsuario(u);
      // Registrar push subscription
      await registrarPush();
      return { ok: true };
    } catch(e) {
      return { ok: false, error: e.response?.data?.error || 'Error al iniciar sesión' };
    } finally { setCargando(false); }
  };

  const logout = () => {
    localStorage.removeItem('gelatus_app_token');
    localStorage.removeItem('gelatus_app_user');
    setUsuario(null);
  };

  const registrarPush = async () => {
    try {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
      const reg = await navigator.serviceWorker.ready;
      const vapidR = await API.get('/app/vapid-public');
      const publicKey = vapidR.data.publicKey;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
      const dispositivo = /iPhone|iPad/.test(navigator.userAgent) ? 'iOS'
        : /Android/.test(navigator.userAgent) ? 'Android' : 'Web';
      await API.post('/app/push-subscribe', { subscription: sub.toJSON(), dispositivo });
    } catch(e) { console.log('Push no disponible:', e.message); }
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, cargando }}>
      {children}
    </AuthContext.Provider>
  );
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}
